/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 70JWAIo687UI

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicMyEvalsHeader.module.css"; // plasmic-import: 70JWAIo687UI/css

createPlasmicElementProxy;

export type PlasmicMyEvalsHeader__VariantMembers = {};
export type PlasmicMyEvalsHeader__VariantsArgs = {};
type VariantPropType = keyof PlasmicMyEvalsHeader__VariantsArgs;
export const PlasmicMyEvalsHeader__VariantProps = new Array<VariantPropType>();

export type PlasmicMyEvalsHeader__ArgsType = {};
type ArgPropType = keyof PlasmicMyEvalsHeader__ArgsType;
export const PlasmicMyEvalsHeader__ArgProps = new Array<ArgPropType>();

export type PlasmicMyEvalsHeader__OverridesType = {
  header?: Flex__<"header">;
  logo?: Flex__<typeof Logo>;
};

export interface DefaultMyEvalsHeaderProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicMyEvalsHeader__RenderFunc(props: {
  variants: PlasmicMyEvalsHeader__VariantsArgs;
  args: PlasmicMyEvalsHeader__ArgsType;
  overrides: PlasmicMyEvalsHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <header
      data-plasmic-name={"header"}
      data-plasmic-override={overrides.header}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.header
      )}
    >
      <Logo
        data-plasmic-name={"logo"}
        data-plasmic-override={overrides.logo}
        className={classNames("__wab_instance", sty.logo)}
        product={"myEvaluations"}
      />
    </header>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  header: ["header", "logo"],
  logo: ["logo"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  header: "header";
  logo: typeof Logo;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMyEvalsHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMyEvalsHeader__VariantsArgs;
    args?: PlasmicMyEvalsHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicMyEvalsHeader__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMyEvalsHeader__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMyEvalsHeader__ArgProps,
          internalVariantPropNames: PlasmicMyEvalsHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMyEvalsHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "header") {
    func.displayName = "PlasmicMyEvalsHeader";
  } else {
    func.displayName = `PlasmicMyEvalsHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicMyEvalsHeader = Object.assign(
  // Top-level PlasmicMyEvalsHeader renders the root element
  makeNodeComponent("header"),
  {
    // Helper components rendering sub-elements
    logo: makeNodeComponent("logo"),

    // Metadata about props expected for PlasmicMyEvalsHeader
    internalVariantProps: PlasmicMyEvalsHeader__VariantProps,
    internalArgProps: PlasmicMyEvalsHeader__ArgProps
  }
);

export default PlasmicMyEvalsHeader;
/* prettier-ignore-end */
